export default "__VITE_ASSET__ZP83ar2___"